// about me component
import React from 'react';

const AboutMe = () => {
    return (
        <div className="container">
        <h2>About Me</h2>
        <p className='cool-hover-gradient-text'>My Name is Yuvraj Arora</p>
        <p>Hi, I'm a software engineer with a passion for environmental sustainability.
        I created this platform to help individuals and communities reduce their carbon footprint.</p>
        </div>
    );
    }

export default AboutMe;